import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import HtmlContent from '../../../youwell-common/components/HtmlContent';

const FaqContent = ({ task, className }) => {
    const translate = useSelector(state => getTranslate(state.localize));

    if (!task) {
        return null;
    }

    return (
        <Accordion className={className}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h5" color="primary">{translate('frontpage.faq')}</Typography>
            </AccordionSummary>

            {task.contentElements.map(el => (
                <Accordion key={el.id} TransitionProps={{ unmountOnExit: true }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>{el.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <HtmlContent html={el.htmlContent} />
                    </AccordionDetails>
                </Accordion>
            ))}
        </Accordion>
    );
};

FaqContent.propTypes = {
    task: PropTypes.object,
    className: PropTypes.string,
};
FaqContent.defaultProps = {
    task: null,
    className: null,
};

export default FaqContent;
